import(/* webpackMode: "eager" */ "/vercel/path0/apps/magicsky/src/app/login/page.tsx");
